import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';
import '../App.css'; // Import the shared CSS

// Generates a random, stable color based on a string (e.g., username)
const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
};

// Modal component to display students
const StudentListModal = ({ students, position, onClose }) => {
    if (!students) return null;

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{position}권 읽은 학생</h3>
                    <button onClick={onClose} className="modal-close-btn">&times;</button>
                </div>
                <div className="modal-body">
                    {students.map(student => (
                        <Link to={`/teacher/student-log/${student.id}`} key={student.id} className="student-card">
                             <span 
                                className="student-card-color-dot" 
                                style={{ backgroundColor: stringToColor(student.username) }}
                            ></span>
                            <span>{student.first_name}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};


const BoardCell = ({ num, isPopulated, onClick }) => {
    let className = 'student-board-cell';
    if (isPopulated) className += ' is-populated-strong'; // New class for stronger emphasis

    return (
        <div className={className} onClick={onClick}>
            <span>{num}</span>
        </div>
    );
};

export default function OverallStatus() {
    const [studentsByPosition, setStudentsByPosition] = useState({});
    const [board, setBoard] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [modalPosition, setModalPosition] = useState(null); // To control the modal

    useEffect(() => {
        const generateBoard = () => {
            const newBoard = [];
            for (let i = 0; i < 10; i++) {
                const row = [];
                for (let j = 0; j < 10; j++) {
                    const num = (i % 2 === 0)
                        ? 100 - (i * 10) - j
                        : (9 - i) * 10 + j + 1;
                    row.push(num);
                }
                newBoard.push(row);
            }
            setBoard(newBoard.flat());
        };

        const fetchStatus = async () => {
            try {
                const { data } = await api.get('/teacher/overall-status/');
                const positionMap = {};
                data.forEach(student => {
                    const pos = student.book_count;
                    if (!positionMap[pos]) {
                        positionMap[pos] = [];
                    }
                    positionMap[pos].push(student);
                });
                setStudentsByPosition(positionMap);
            } catch (err) {
                setError('데이터를 불러오는 데 실패했습니다.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        generateBoard();
        fetchStatus();
    }, []);

    const handleCellClick = (num) => {
        if (studentsByPosition[num]) {
            setModalPosition(num);
        }
    };

    const closeModal = () => {
        setModalPosition(null);
    };

    if (loading) return <Layout><p>로딩 중...</p></Layout>;
    if (error) return <Layout><p className="message error">{error}</p></Layout>;

    return (
        <Layout>
            <Link to="/teacher" className="back-link">선생님 홈으로</Link>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <h1>전체 독서 현황</h1>
            </div>

            <div className="board-wrapper">
                <div className="student-board-container">
                    {board.map(num => (
                        <BoardCell
                            key={num}
                            num={num}
                            isPopulated={!!studentsByPosition[num]}
                            onClick={() => handleCellClick(num)}
                        />
                    ))}
                </div>
            </div>

            {modalPosition && (
                <StudentListModal
                    students={studentsByPosition[modalPosition]}
                    position={modalPosition}
                    onClose={closeModal}
                />
            )}
        </Layout>
    );
}
